export default __webpack_public_path__ + "static/media/client-19.2c46d03b.png";